import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { LicenseAddEditConfig } from './license-add-edit-config';

@Injectable({
  providedIn: 'root'
})
export class LicenseAddEditModalModalService extends BaseModalService<LicenseAddEditConfig> {}
